import { TFunction } from 'i18next';
import * as Yup from 'yup';
import { removeHTMLTags } from 'shared/utils';
import { getHoursValidationSchema } from 'features/locations/utils/getHoursValidationSchema';
import { getLinksValidationSchema } from 'components/FormLinks';
import { reporterNotesValidationSchema } from 'features/reporterNotes/reporterNotes.utils';

export const getValidationSchema = (
  t: TFunction,
  requiresIncidentAssociation = false,
): Yup.SchemaOf<object> =>
  Yup.object().shape({
    name: Yup.string().required(t('createEditLocation.inputs.name.required')),
    address: Yup.string().required(
      t('createEditLocation.inputs.address.required'),
    ),
    type: Yup.string()
      .required(t('createEditLocation.inputs.type.required'))
      .nullable(),
    parentGeoEvents: requiresIncidentAssociation
      ? Yup.array(Yup.object()).min(
          1,
          t('createEditLocation.inputs.incidents.required'),
        )
      : Yup.array(Yup.object()),
    status: Yup.string().required(
      t('createEditLocation.inputs.status.required'),
    ),
    information: Yup.string().test(
      'is-min-length',
      t('createEditLocation.inputs.information.minError'),
      (value) => {
        const parsedValue = value
          ? removeHTMLTags(value).replace(/\s/g, '')
          : '';
        return parsedValue.length >= 15;
      },
    ),
    expandLinks: Yup.boolean(),
    links: getLinksValidationSchema(t),
    lat: Yup.number(),
    lng: Yup.number(),
    regions: Yup.array(Yup.object()),
    expandHours: Yup.boolean(),
    hours: getHoursValidationSchema(t),
    atCapacity: Yup.boolean(),
    reporterOnlyNotes: Yup.string().nullable(),
    ...reporterNotesValidationSchema,
  });
